import { render, staticRenderFns } from "./VR2.vue?vue&type=template&id=36982700&scoped=true"
import script from "./VR2.vue?vue&type=script&lang=js"
export * from "./VR2.vue?vue&type=script&lang=js"
import style0 from "./VR2.vue?vue&type=style&index=0&id=36982700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36982700",
  null
  
)

export default component.exports